<template>
  <InputCombobox
    v-bind="inheritedAttrs"
    v-model="selectedUnit"
    @update:model-value="(val) => (modelValue = val?.key)"
    :items="unitList"
    items-key-name="key"
    items-value-name="value"
    :items-filter-fn="
      (item, query) => item.value.includes(query) || item.alternative.includes(query)
    "
    :editable="false"
    ref="inputCombobox"
  >
    <template v-if="$slots['before-input']" #before-input>
      <slot name="before-input" />
    </template>
  </InputCombobox>
</template>

<script setup lang="ts">
import { Units } from "@/enums/units.enum"
import InputCombobox from "@/components/inputs/input_combobox/InputCombobox.vue"
import { computed, ref, useAttrs, watch } from "vue"
import { getUnitList } from "@/helper/enums/unit-helper"

const modelValue = defineModel<Units | undefined>({ default: undefined })

// Do not inherit all attrs because v-model will be inherited by InputCombobox, which we don't want
defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()

const inheritedAttrs = computed((): Record<string, unknown> => {
  const _inheritedAttrs: Record<string, unknown> = { ...attrs }
  delete _inheritedAttrs["v-model"] // We want all attrs to be inherited, except v-model
  delete _inheritedAttrs["v-on:input"] // We want all attrs to be inherited, except v-model
  return _inheritedAttrs
})

const inputCombobox = ref()

defineExpose({
  focus: () => inputCombobox.value.focus()
})

const selectedUnit = ref()
const unitList = getUnitList()

watch(
  () => modelValue.value,
  (val) => {
    selectedUnit.value = unitList.find((unit) => unit.key.toString() === val?.toString())
  },
  { immediate: true }
)
</script>

<style scoped></style>
